// Screen metadata, free of component imports so both routes.js and the user
// management views can depend on it without an import cycle. routes.js attaches
// the React components; this file owns keys, labels and the role defaults.

export const screenKey = path => path.replace("/", "");

// Single source of truth for the screen universe. Order drives the sidebar.
const buildScreen = (key, name, icon, hidden = false) => ({
  key,
  name,
  icon,
  path: `/${key}`,
  hidden,
});

export const SCREENS = [
  buildScreen("instruments_panel", "Painel de Instrumentos", "nc-icon nc-chart-bar-32"),
  buildScreen("processes_management", "Gerenciar Processos", "nc-icon nc-bullet-list-67"),
  buildScreen("schedule", "Programação", "nc-icon nc-calendar-60"),
  buildScreen("shipment_report", "Relatório de carga", "nc-icon nc-chart-pie-36"),
  buildScreen("umidity", "Umidades", "nc-icon nc-sound-wave"),
  buildScreen("stock_materials", "Materiais em Estoque", "nc-icon nc-tag-content"),
  buildScreen("families_formulas", "Famílias e traços", "nc-icon nc-vector"),
  buildScreen("general_registers", "Cadastros Gerais", "nc-icon nc-send"),
  buildScreen("automation_status", "Status da Automação", "nc-icon nc-settings-gear-65"),
  buildScreen("controller_settings", "Configurações", "nc-icon nc-settings"),
  buildScreen("requests", "Requisições", null, true),
  // Superuser-only, reachable by direct URL (/admin/user_management); kept out of
  // the sidebar on purpose.
  buildScreen("user_management", "Gerenciamento de Usuários", null, true),
];

// Historical role→screen mapping. This is the baseline a per-user override
// deviates from, so it must mirror the old hardcoded routing exactly.
const BASE_KEYS = ["instruments_panel", "processes_management", "shipment_report", "automation_status"];
const OFFLINE_KEYS = [
  "instruments_panel", "processes_management", "schedule", "shipment_report",
  "umidity", "stock_materials", "families_formulas", "general_registers", "automation_status",
];
// user_management is reachable by admin too (URL-only, like for superuser); the
// backend scopes what an admin may see/do there.
const ADMIN_KEYS = [...OFFLINE_KEYS, "controller_settings", "requests", "user_management"];

export const isScreenVisibleByDefault = (role, key) => {
  if (role === "SUPERUSER") return true;
  if (role === "API_USER" || role === "RESTRICTED_USER") return BASE_KEYS.includes(key);
  if (role === "ADMIN") return ADMIN_KEYS.includes(key);
  return OFFLINE_KEYS.includes(key); // USER and any unknown role
};

// Effective visibility: a stored override wins over the role default. Superuser
// is never affected by an override, which keeps them lockout-safe.
export const isScreenVisible = (role, key, overrides) => {
  if (role === "SUPERUSER") return true;

  const hasOverride = overrides && Object.prototype.hasOwnProperty.call(overrides, key);
  return hasOverride ? overrides[key] : isScreenVisibleByDefault(role, key);
};

// Screens a superuser can grant/block per user. user_management is left out on
// purpose: it is superuser-only and enforced on the backend, so granting it to
// anyone else would only show a page whose operations all fail.
export const screenCatalog = SCREENS
  .filter(screen => screen.key !== "user_management")
  .map(screen => ({ key: screen.key, label: screen.name, hidden: Boolean(screen.hidden) }));
